export const formatCurrency = (inputValue) => {
    // Remove todos os caracteres não numéricos
    const numericValue = inputValue.replace(/[^\d]/g, '');

    // Divide o valor em parte inteira e decimal
    const integerValue = numericValue.slice(0, -2);
    const decimalValue = numericValue.slice(-2);

    // Formata a parte inteira com ponto como separador de milhar
    let formattedInteger = '';
    for (let i = integerValue.length - 1, j = 1; i >= 0; i--, j++) {
        formattedInteger = integerValue[i] + formattedInteger;
        if (j % 3 === 0 && i !== 0) {
            formattedInteger = '.' + formattedInteger;
        }
    }

    // Concatena a parte inteira e a parte decimal formatadas
    const formattedValue = inputValue != "" ? `${formattedInteger},${decimalValue}` : '';

    return formattedValue;
};